module.exports = __webpack_public_path__ + "Panton-Bold.d50542ead667.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Panton-Bold.eot
// module id = ./src/styles/fonts/Panton-Bold.eot
// module chunks = 21